import { useMaintenance } from '@/maintenance/store';
import { MaintenanceScreen } from '@/maintenance/MaintenanceScreen';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import { useEffect } from 'react';
import { AccessPendingScreen } from './AccessPendingScreen';

const PORTAL_LOGIN_URL = 'https://nadc1.net/login';

export function ProtectedRoute() {
  const maintenance = useMaintenance();
  const { isAuthenticated, isLoading, isRedirecting, user } = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    // If not loading and not authenticated, redirect to portal — unless
    // AuthContext is already on its way there (an expired session signs the
    // tab out and redirects itself; a second hand-off here would race it).
    if (!maintenance && !isLoading && !isAuthenticated && !isRedirecting) {
      const currentUrl = encodeURIComponent(window.location.href);
      window.location.href = `${PORTAL_LOGIN_URL}?redirect=${currentUrl}`;
    }
  }, [maintenance, isLoading, isAuthenticated, isRedirecting]);

  if (maintenance && !isAuthenticated) return <MaintenanceScreen />;

  // Don't render while loading or if not authenticated
  if (isLoading || !isAuthenticated) {
    return null;
  }

  // Signed in with nothing given yet: the waiting page, not an empty app —
  // except an invoice sent to them. AP can route an invoice to someone who
  // has never signed in (the directory picker creates their account), and an
  // assignee acts on it with no role at all; the server checks that.
  if (user?.access_pending && !/^\/invoices\/[^/]+\/?$/.test(pathname)) {
    return <AccessPendingScreen name={user.first_name} />;
  }

  return <Outlet />;
}
